var map = {
	"./add-wallet.png": "6xn9",
	"./avatar/Ellipse42.png": "J7V8",
	"./avatar/store.png": "FoAh",
	"./bank/baac.png": "yCg9",
	"./bank/bay.png": "RRSd",
	"./bank/bbl.png": "9a1T",
	"./bank/cimb.png": "i+Aq",
	"./bank/ghb.png": "4mBp",
	"./bank/gsb.png": "KteS",
	"./bank/ibank.png": "C1gS",
	"./bank/icbc.png": "mg+6",
	"./bank/kbank.png": "MOE8",
	"./bank/kk.png": "0td9",
	"./bank/ktb.png": "KiQr",
	"./bank/lhb.png": "0xBg",
	"./bank/none.png": "AAwx",
	"./bank/sc.png": "9pLU",
	"./bank/scb.png": "chyL",
	"./bank/tbank.png": "jrNC",
	"./bank/tisco.png": "ivCk",
	"./bank/tmb.png": "BNqE",
	"./bank/uob.png": "g65J",
	"./carrier/4.png": "L/vp",
	"./carrier/450px.png": "lSVw",
	"./carrier/5.png": "xz2H",
	"./carrier/550px.png": "bbx9",
	"./carrier/6.png": "kyb9",
	"./carrier/650px.png": "2oPy",
	"./carrier/8.png": "YuRF",
	"./carrier/850px.png": "1Dsv",
	"./carrier/FLASH_EXPRESS.png": "G3Iw",
	"./carrier/KERRY_EXPRESS.png": "9rMM",
	"./carrier/THAIPOST.png": "pc+J",
	"./carrier/_4.png": "Ql42",
	"./carrier/_5.png": "3D6F",
	"./carrier/_6.png": "lvDy",
	"./carrier/_8.png": "zr0V",
	"./carrier/_THAIPOST.png": "gjai",
	"./carrier/__6.png": "DoGP",
	"./carrier/___5.png": "AEuf",
	"./carrier/i-dhl.png": "96UE",
	"./carrier/i-jt.png": "CW8N",
	"./channel/1.png": "bCfX",
	"./channel/10.png": "tm8i",
	"./channel/11.png": "MfMV",
	"./channel/2.png": "1P7/",
	"./channel/3.png": "kVfp",
	"./channel/9.png": "n9OC",
	"./channel/Application.png": "MI9l",
	"./channel/Salepage.png": "ZEbH",
	"./channel/Telesales.png": "ligH",
	"./coming-soon.png": "i45P",
	"./credit-card-support.png": "1nyA",
	"./dummy/channel/laz.png": "XOOh",
	"./dummy/channel/shop.png": "Tri6",
	"./dummy/demo_profile.png": "NQDU",
	"./dummy/payment/Group206.png": "iAo3",
	"./dummy/payment/Group3731.png": "lnkv",
	"./dummy/payment/bangkok.png": "2xbf",
	"./dummy/payment/kbank.png": "9qW0",
	"./dummy/product/product1.png": "1Rby",
	"./dummy/product/product2.png": "dIRl",
	"./dummy/shipping/DHL.png": "Grh5",
	"./dummy/shipping/JT.png": "WGwl",
	"./dummy/user-profile.png": "xnM1",
	"./dummy/user.png": "yt9J",
	"./file-image.png": "Mo+f",
	"./frontend/integration_channel/1.png": "T/6n",
	"./frontend/integration_channel/2.png": "o9GD",
	"./frontend/integration_channel/3.png": "axyN",
	"./frontend/integration_channel/Application.png": "/rdF",
	"./frontend/integration_channel/Salepage.png": "NYM/",
	"./frontend/integration_channel/Telesales.png": "FIaL",
	"./frontend/integration_channel/Tiktok.png": "yiDq",
	"./frontend/integration_channel/instagram.png": "Sf99",
	"./frontend/integration_channel/youtube-square-brands 2.png": "k8rX",
	"./frontend/logo/_logo.png": "QUcE",
	"./frontend/logo/logo.png": "C+ms",
	"./img-sms.png": "9sjM",
	"./integration/1.png": "D6Jk",
	"./integration/2.png": "jmgs",
	"./integration/3.png": "ux60",
	"./integration/Application.png": "bPlq",
	"./integration/Salepage.png": "BOaQ",
	"./integration/Telesales.png": "YTvp",
	"./integration/Tiktok.png": "c11D",
	"./integration/instagram.png": "0BAw",
	"./integration/youtube-square-brands 2.png": "qD4C",
	"./lang/en-US.png": "aXBa",
	"./lang/en.png": "MiCS",
	"./lang/th.png": "1D3S",
	"./logo.png": "iQH9",
	"./no-image-2.png": "+oEG",
	"./no-image-label.png": "KBYp",
	"./no-image-profile.png": "1eI5",
	"./no-image-user.png": "NaKZ",
	"./no-image.png": "xxmW",
	"./payment/1.png": "vRJy",
	"./payment/2.png": "KmS4",
	"./payment/3.png": "uHgC",
	"./payment/Kbank_payment_logo.png": "9anU",
	"./payment/banktransfer.png": "FKUF",
	"./payment/card.png": "epkF",
	"./payment/credit_card_support.png": "Uib6",
	"./payment/free.png": "jZVF",
	"./payment/logo_Kbank.png": "olVk",
	"./payment/promptPay2.png": "Y8aU",
	"./payment/qr_code.png": "pHZL",
	"./payment/qrcode.png": "m9Ro",
	"./shipping/Failed_1.png": "J0sC",
	"./shipping/PromptPay2.png": "iyPs",
	"./shipping/thank_you_mail_1.png": "cyL2",
	"./watting.png": "Swi7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 150